import api from '@/api';

const state = {
    suppliers: [],
};

const mutations = {
    setSuppliers(state, suppliers) {
        state.suppliers = suppliers;
    },
};

const actions = {
    async loadSuppliers({ commit }) {
        const response = await api.suppliers.list();
        commit('setSuppliers', response.data);
    },
};

const getters = {
    suppliers() {
        return state.suppliers || [];
    },
    suppliersValueText(_, getters) {
        return getters.suppliers.map(({ id, name }) => ({ value: id, text: name }));
    },
    suppliersDictionary(_, getters) {
        return getters.suppliers.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/suppliers.js